import { bindServices } from '@/services/api';

const api = bindServices('billingCheckout');

const namespace = 'billingCheckout';
const checkoutStatusRoute = 'billing/payment-sessions/checkout-status';

const initialState = {
  status: null,
  loading: false,
  error: null,
  pollingTimedOut: false,
};

const BillingCheckoutModel = {
  namespace,
  state: initialState,

  effects: {
    *fetchCheckoutStatus({ payload }, { call, put }) {
      const silent = payload?.silent;

      if (!silent) {
        yield put({
          type: 'setCheckoutStatusState',
          payload: { loading: true, error: null, pollingTimedOut: false },
        });
      }

      try {
        const paymentSessionId = payload?.paymentSessionId;
        const route = paymentSessionId
          ? `${checkoutStatusRoute}?paymentSessionId=${encodeURIComponent(paymentSessionId)}`
          : checkoutStatusRoute;

        const res = yield call(api.getAll, {
          route,
          readPriority: true,
        });

        yield put({
          type: 'setCheckoutStatusState',
          payload: { loading: false, status: res, error: null },
        });
      } catch (e) {
        if (silent) {
          yield put({
            type: 'setCheckoutStatusState',
            payload: { loading: false },
          });
          return;
        }

        yield put({
          type: 'setCheckoutStatusState',
          payload: { loading: false, error: e?.message || 'FETCH_ERROR' },
        });
      }
    },

    *resetState(_, { put }) {
      yield put({ type: 'reset' });
    },
  },

  reducers: {
    setCheckoutStatusState(state, { payload }) {
      return { ...state, ...payload };
    },

    setPollingTimedOut(state, { payload }) {
      return { ...state, pollingTimedOut: payload };
    },

    reset() {
      return { ...initialState };
    },
  },
};

export default BillingCheckoutModel;
